import {AgregarExterno} from "./AgregarExterno";
import {postExternFundeo, putExternFundeo} from "../../../services/familia/fundeo";

export const AddExternoFundeo = () => {
    return (
        <AgregarExterno post={postExternFundeo} familiaURL={"/familia/fundeo"} name={"Fundación Enrique Osso"} logo={"logoFUNDEO.png"} put={putExternFundeo}/>
    )
}